var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-50 image"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.imageUrl,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }